<div class="page-wrap" #mainLayout>
  <mat-progress-bar [mode]="mode" [color]="color" *ngIf="loader" class="loader resolve_loader"></mat-progress-bar>
  <div class="outlet_wrapper"><router-outlet></router-outlet></div>
</div>